<template>
  <div :class="['sponsors-column', { 'sponsors-two-col': isTwoColumn }]">
    <div
      v-for="({ company, details, id }, i) in sponsors"
      :key="id"
      :class="['sponsor-cell', `tier-${tierName}`, { 'sponsor-cell-full': isTwoColumn && sponsors.length % 2 !== 0 && i === sponsors.length - 1 }]"
    >
      <router-link
        :to="{
          name: 'companyProfile',
          params: { companyId: getId(company) },
        }"
        exact
        class="company-logo-link"
      >
        <img
          :class="['sponsor-img', `sponsor-img-${tierName}`]"
          :src="details.logo"
          :alt="details.name || 'Sponsor logo'"
        />
      </router-link>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import getIDfromURL from '../../utils/getIDfromURL';

export default {
  props: {
    categoryId: {
      type: Number,
      default: '',
    },
    index: {
      type: Number,
      default: '',
    },
    categoryName: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      sponsors: [],
    };
  },
  watch: {
    $route: {
      async handler(route) {
        if (route.params.eventId) {
          this.sponsors = await this.fetchEventSponsors(this.categoryId);
        } else if (route.params.awardId) {
          this.sponsors = await this.fetchAwardSponsors(this.categoryId);
        }
      },
    },
  },
  async mounted() {
    if (this.$route.params.eventId) {
      this.sponsors = await this.fetchEventSponsors(this.categoryId);
    }
    if (this.$route.params.awardId) {
      this.sponsors = await this.fetchAwardSponsors(this.categoryId);
    }
  },
  computed: {
    tierName() {
      const names = ['platinum', 'gold', 'silver', 'associate'];
      return names[Math.min(this.index, names.length - 1)] || 'associate';
    },
    isTwoColumn() {
      const name = this.categoryName.toLowerCase();
      return name.includes('gold') || name.includes('silver') || name.includes('associate');
    },
  },
  methods: {
    ...mapActions({
      fetchEventSponsors: 'events/fetchEventSponsors',
      fetchAwardSponsors: 'awards/fetchAwardSponsors',
    }),
    getId(url) {
      return getIDfromURL(url);
    },
  },
};
</script>

<style scoped>
.sponsors-column {
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
  border-radius: 0 0 10px 10px;
  overflow: hidden;
}

.sponsors-two-col {
  display: grid;
  grid-template-columns: 1fr 1fr;
}

.sponsors-two-col .sponsor-cell {
  border-top: 1px solid #e0e0e0;
  border-right: 1px solid #e0e0e0;
}

.sponsors-two-col .sponsor-cell:nth-child(2n) {
  border-right: none;
}

.sponsors-two-col .sponsor-cell:nth-child(-n+2) {
  border-top: none;
}

.sponsor-cell-full {
  grid-column: 1 / -1;
  border-right: none !important;
}

.sponsor-cell {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 80px;
  padding: 12px 16px;
  border-top: 1px solid #e0e0e0;
  box-sizing: border-box;
}
.sponsor-cell:first-child {
  border-top: none;
}

/* Fixed container heights by tier */
.sponsor-cell.tier-platinum {
  min-height: 120px;
}
.sponsor-cell.tier-gold {
  min-height: 110px;
  padding: 8px 12px;
}
.sponsor-cell.tier-silver {
  min-height: 80px;
  padding: 26px 36px;
}
.sponsor-cell.tier-associate {
  min-height: 64px;
}

.company-logo-link {
  display: flex;
  align-items: center;
  justify-content: center;
  max-width: 100%;
  height: 100%;
  min-width: 0;
}

.sponsor-img {
  border-style: none;
  object-fit: contain;
}

/* Logo size decreases by tier: platinum largest → associate smallest */
.sponsor-img-platinum {
  max-width: 200px;
  max-height: 100px;
  width: 100%;
}
.sponsor-img-gold {
  max-width: 170px;
  max-height: 86px;
  width: 100%;
}
.sponsor-img-silver {
  max-width: 100px;
  max-height: 50px;
  width: 100%;
}
.sponsor-img-associate {
  max-width: 96px;
  max-height: 48px;
  width: 100%;
}
</style>
